export default __webpack_public_path__ + "0533c55fe79ea0b2b6c7f8e6397ac999.png";